// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__3pjNE","content":"Consent_content__1bYAo","footer":"Consent_footer__11uuA"};